import { render, staticRenderFns } from "./test1-5.vue?vue&type=template&id=c2ce42d6&scoped=true"
import script from "./test1-5.vue?vue&type=script&lang=js"
export * from "./test1-5.vue?vue&type=script&lang=js"
import style0 from "./test1-5.vue?vue&type=style&index=0&id=c2ce42d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ce42d6",
  null
  
)

export default component.exports